import * as Types from '../../../types/gql';

export type SwiftSuggestionVariables = Types.Exact<{
  substring: Types.Scalars['String'];
}>;

export type SwiftSuggestion = {
  clearing?: Types.Maybe<{
    abroadBankInfoList?: Types.Maybe<Array<{ swift: string; name: string; address: string }>>;
  }>;
};
